import {
  calendarDateSchema,
  DASHBOARD_CATEGORIES,
  DASHBOARD_DUE,
  idSchema,
  LIMITS,
  UNASSIGNED,
} from '@wednesday/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DashboardPage } from '@/features/insights/dashboard-page';

/** DSH-1: the Dashboard is the home page; its filters live in the URL (DSH-2). */
export const Route = createFileRoute('/_app/')({
  validateSearch: z.object({
    projects: z.array(idSchema).max(200).optional().catch(undefined),
    people: z
      .array(z.union([idSchema, z.literal(UNASSIGNED)]))
      .max(200)
      .optional()
      .catch(undefined),
    q: z.string().max(LIMITS.searchQueryMax).optional().catch(undefined),
    due: z.enum(DASHBOARD_DUE).optional().catch(undefined),
    from: calendarDateSchema.optional().catch(undefined),
    to: calendarDateSchema.optional().catch(undefined),
    /** D43: the number, slice or bar whose work items are listed in a panel. */
    show: z
      .object({
        category: z.enum(DASHBOARD_CATEGORIES).optional(),
        statusId: idSchema.optional(),
        owner: z.union([idSchema, z.literal(UNASSIGNED)]).optional(),
        overdue: z.boolean().optional(),
      })
      .optional()
      .catch(undefined),
  }),
  component: DashboardPage,
});
